import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TabItem } from "components/elements/Tabs/Tabs";
import InboxTable from "./components/InboxTable";

interface InboxPageTabsReturn {
  tabItems: TabItem[];
  activeTab: TabItem;
  handleTabChange: (tab: TabItem) => void;
}

const useInboxPageTabs = (): InboxPageTabsReturn => {
  const { t } = useTranslation(["common"]);
  const navigate = useNavigate();
  const { tabSlug } = useParams<{ tabSlug: string }>();

  const tabItems: TabItem[] = [
    {
      key: "all-inbox",
      name: t("inbox.all_inbox_tab_label"),
      url: "all-inbox",
      mainComponent: <InboxTable tabKey={"all-inbox"} />,
    },
    {
      key: "unmatched",
      name: t("inbox.unmatched_tab_label"),
      url: "unmatched",
      mainComponent: <InboxTable tabKey={"unmatched"} />,
    },
    {
      key: "unassigned",
      name: t("inbox.unassigned_tab_label"),
      url: "unassigned",
      mainComponent: <InboxTable tabKey={"unassigned"} />,
    },
  ];

  const getTabFromUrl = (): TabItem | undefined => {
    return tabItems.find((tab) => tab.url === tabSlug);
  };

  const defaultTab = getTabFromUrl() || tabItems[0];

  const [activeTab, setActiveTab] = useState<TabItem>(defaultTab);

  const handleTabChange = (tab: TabItem) => {
    navigate(`/inbox/${tab.url}`);
    setActiveTab(tab);
  };

  useEffect(() => {
    handleTabChange(defaultTab);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabSlug]);

  return {
    tabItems,
    activeTab,
    handleTabChange,
  };
};

export default useInboxPageTabs;
